import React, { Component } from 'react';

// Components
import Header from './assets/components/header';
import Video from './assets/components/video';
import ConnectingWorld from './assets/components/connectingWorld';
import EverydayPeople from './assets/components/everydayPeople';
import Connect from './assets/components/connect';
import Simplicity from './assets/components/simplicity';
import TheRightPeople from './assets/components/theRightPeople';
import ThreeKeys from './assets/components/threeKeys';
import Join from './assets/components/join';
import Grow from './assets/components/grow';
import SignUp from './assets/components/signUp';
import Footer from './assets/components/footer';

// Includes
import './assets/css/default.min.css';


class App extends Component {
  render() {
    return (
        <div className="App container-fluid">

          <Header />

            <Video />
            <ConnectingWorld />
            <EverydayPeople />
            <Connect />
            <Simplicity />
            <TheRightPeople />
            <ThreeKeys />
            <Join />
            <Grow />
            <SignUp />

          <Footer />

        </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js